const type = 'OPEN_CARD_STATUS_CHANGE';

const openCardStatusChange = () => ({
  type,
});

export { type };
export default openCardStatusChange;
